import IconButton from "@mui/material/IconButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

const CampaignTableExpandButton = ({
  expanded = false,
  onToggle = () => {},
  expandLabel = "",
  collapseLabel = "",
}) => (
  <IconButton
    size="small"
    aria-expanded={expanded}
    aria-label={expanded ? collapseLabel : expandLabel}
    onMouseDown={(event) => event.stopPropagation()}
    onClick={(event) => {
      event.preventDefault();
      event.stopPropagation();
      onToggle();
    }}
    sx={{ p: 0.25, flexShrink: 0 }}
  >
    {expanded ? (
      <KeyboardArrowDownIcon fontSize="small" />
    ) : (
      <KeyboardArrowRightIcon fontSize="small" />
    )}
  </IconButton>
);

export default CampaignTableExpandButton;
